import { Action } from 'redux';
import { OrderedMap } from 'immutable';

import {
    GET_RUBRICS_REQUEST,
    GET_RUBRICS_RESPONSE,
    GET_RUBRICS_ERROR,

    GET_TEMPLATES_REQUEST,
    GET_TEMPLATES_RESPONSE,
    GET_TEMPLATES_ERROR,

    SET_RUBRIC,
} from '../../actions/Legal/legal';

import { Rubric } from '../../models/Legal/Rubric';
import { Template } from '../../models/Legal/Template';

export interface LegalState {
    rubrics: OrderedMap<number, Rubric>;
    loadingRubrics: boolean;
    errorRubrics: any;

    rubric: Rubric;

    templates: OrderedMap<number, Template>;
    loadingTemplates: boolean;
    errorTemplates: any;
}

const initialState: LegalState = {
    rubrics: OrderedMap<number, Rubric>(),
    loadingRubrics: false,
    errorRubrics: null,

    rubric: {} as Rubric,

    templates: OrderedMap<number, Template>(),
    loadingTemplates: false,
    errorTemplates: null
};

export function legalState(state: LegalState = initialState, action: Action) {
    switch (action.type) {
        case GET_RUBRICS_REQUEST: {
            return {
                ...state,
                rubrics: initialState.rubrics,
                loadingRubrics: true,
                errorRubrics: initialState.errorRubrics,
            };
        }
        case GET_RUBRICS_RESPONSE: {
            const result: Rubric[] = (action as any).response.result;
            const rubrics = result.reduce((prev, cur) => prev.set(cur.id, cur), initialState.rubrics);
            return {
                ...state,
                loadingRubrics: false,
                rubrics,
            };
        }
        case GET_RUBRICS_ERROR: {
            const errorRubrics = (action as any).error;
            return {
                ...state,
                loadingRubrics: false,
                errorRubrics,
            };
        }

        case GET_TEMPLATES_REQUEST: {
            return {
                ...state,
                templates: initialState.templates,
                loadingTemplates: true,
                errorTemplates: initialState.errorTemplates,
            };
        }
        case GET_TEMPLATES_RESPONSE: {
            const result: Template[] = (action as any).response.result;
            const templates = result.reduce((prev, cur) => prev.set(cur.id, cur), initialState.templates);
            return {
                ...state,
                loadingTemplates: false,
                templates,
            };
        }
        case GET_TEMPLATES_ERROR: {
            const errorTemplates = (action as any).error;
            return {
                ...state,
                loadingTemplates: false,
                errorTemplates,
            };
        }

        case SET_RUBRIC: {
            const rubric = (action as any).rubric;
            localStorage.setItem('legal_rubric', JSON.stringify(rubric));
            return {
                ...state,
                rubric,
            };
        }
        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/reducers/Legal/legal.ts